import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { delay, Observable } from "rxjs"
import { CurrencyPurchaseSelectionDto } from "../model/currency-purchase.selection.model"
import { CurrencyPurchaseDto } from "../model/currency-purchase.model"

@Injectable({ providedIn: 'root' })
export class CurrencyPurchaseApi {
delayMs: number = 500;

    constructor(
        private _httpClient: HttpClient
    ) {
        
    }

    getDefault(): Observable<CurrencyPurchaseDto> {
        // return of(this.mockDataDefault);
        return this._httpClient
            .get<CurrencyPurchaseDto>(`api/currency-rate/default`, { withCredentials: true })
    }

    changeItem(item: CurrencyPurchaseDto): Observable<CurrencyPurchaseDto> {
        return this._httpClient
            .post<CurrencyPurchaseDto>(`api/order/calculation/currency-purchase`, item, { withCredentials: true })
            .pipe(
                delay(this.delayMs) // délai en millisecondes
            );
    }
    
    getDetailSelection(currencyPurchaseDto?: CurrencyPurchaseDto) {
        // return of(this.mockDataSelection);
        return this._httpClient
            .get<CurrencyPurchaseSelectionDto>(`api/currency-rate/selection`, { withCredentials: true })
    }

    // mockDataDefault: CurrencyPurchaseDto = {
    //     id: 1,
    //     sourceCurrency: {id:1, label: '', labelLCode:'customer_rate.label.eur_label', code:'EUR', imgPath:'images/currency/eur.svg', symbol:'', sellRate:0.05, denominationMin:10},
    //     sourceAmount: 500,
    //     targetCurrency: {id:14, label: '', labelLCode:'customer_rate.label.usd_label', code:'USD', imgPath:'images/currency/usd.svg', symbol:'', sellRate:0.05, denominationMin:10},
    //     targetAmount: 1.25*500
    // };

    // mockDataSelection: CurrencyPurchaseSelectionDto = {
    //     currency: [
    //         { id: 1, label:'', labelLCode:'customer_rate.label.eur_label', code: 'EUR', imgPath: 'images/currency/eur.svg', symbol:'', sellRate:0.05, denominationMin:10 },
    //         { id: 2, label:'', labelLCode:'customer_rate.label.usd_label', code: 'USD', imgPath: 'images/currency/usd.svg', symbol:'', sellRate:0.05, denominationMin:10 },
    //         { id: 3, label:'', labelLCode:'customer_rate.label.chf_label', code: 'CHF', imgPath: 'images/currency/chf.svg', symbol:'', sellRate:0.05, denominationMin:10 },

    //     ]
    // };
}
